/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shopping_All_DoneInputs */

const en_shopping_all_done = /** @type {(inputs: Shopping_All_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All checked off, nothing left.`)
};

const de_shopping_all_done = /** @type {(inputs: Shopping_All_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles abgehakt, nichts mehr offen.`)
};

/**
* | output |
* | --- |
* | "All checked off, nothing left." |
*
* @param {Shopping_All_DoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_all_done = /** @type {((inputs?: Shopping_All_DoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_All_DoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_all_done(inputs)
	return en_shopping_all_done(inputs)
});